export default {"src":"/_next/static/media/bxs-gift.e88a7b6b.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};